"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

require("styles/theme");

require("styles/theme.scss.liquid");

var _View2 = _interopRequireDefault(require("app/View"));

var _turbolinks = _interopRequireDefault(require("turbolinks"));

var _helpers = require("utils/helpers");

require("focus-visible");

require("components/social-links");

require("components/cta");

require("components/footer");

require("components/wysiwyg");

require("components/tagline");

require("components/promobar");

require("components/skip-link");

require("components/inline-svg");

require("components/headline");

require("components/callout");

require("components/fake-input-cta");

require("components/fullscreen-hero");

require("components/shopify-challenge");

require("components/center-hero");

require("components/newsletter-hero");

require("components/text-center-block");

require("components/half-image-with-description");

require("components/text-section-2-3");

require("components/image-section-2-3");

require("components/fullscreen-image");

require("components/image-section-big");

require("components/two-images");

require("components/image-as-link-to-product");

require("components/inline-product-grid");

require("components/inline-product-card");

require("components/values-icon");

require("components/values-icon-grid");

require("components/action-card");

require("components/utility-hero");

require("components/utility-navigation");

require("components/klaviyo-sms-form");

require("components/button-switch");

var _media = _interopRequireDefault(require("components/media"));

var _header = _interopRequireDefault(require("components/header"));

var _accordian = _interopRequireDefault(require("components/accordian"));

var _additivesPopup = _interopRequireDefault(require("components/additives-popup"));

var _newsletterPopup = _interopRequireDefault(require("components/newsletter-popup"));

var _klaviyoNewsletterForm = _interopRequireDefault(require("components/klaviyo-newsletter-form"));

var _locationbar = _interopRequireDefault(require("components/locationbar"));

require("components/article");

require("components/article-hero");

require("components/article-text-block");

require("components/article-image-block");

require("components/article-checklist-block");

require("components/article-html-block");

require("components/article-spotify-block");

require("components/article-callout");

require("components/article-callout-grid");

require("components/article-listing");

require("components/article-listing-card");

require("components/article-card");

require("components/article-comments");

var _articleVideoBlock = _interopRequireDefault(require("components/article-video-block"));

var _articleGalleryBlock = _interopRequireDefault(require("components/article-gallery-block"));

require("components/cart-item");

require("components/mini-cart-item");

var _cart = _interopRequireDefault(require("components/cart"));

var _miniCart = _interopRequireDefault(require("components/mini-cart"));

var _productQuantityNumber = _interopRequireDefault(require("components/product-quantity-number"));

var _credits = _interopRequireDefault(require("components/credits"));

var _searchPanel = _interopRequireDefault(require("components/search-panel"));

var _videoSection = _interopRequireDefault(require("components/video-section"));

var _stockist = _interopRequireDefault(require("components/stockist"));

var _stockistTab = _interopRequireDefault(require("components/stockist-tab"));

var _stripHero = _interopRequireDefault(require("components/strip-hero"));

var _filterPanel = _interopRequireDefault(require("components/filter-panel"));

var _sizeGuide = _interopRequireDefault(require("components/size-guide"));

require("components/paywhirl-customize");

var _paywhirlInfoOverlay = _interopRequireDefault(require("components/paywhirl-info-overlay"));

require("components/product-card");

var _productCardGrid = _interopRequireDefault(require("components/product-card-grid"));

require("components/product-actions");

require("components/product-details");

require("components/product-gallery");

var _productGalleryNative = _interopRequireDefault(require("components/product-gallery-native"));

require("components/product-hero-desktop");

require("components/product-find-in-store");

require("components/related-products");

var _fullscreenImageWithNav = _interopRequireDefault(require("components/fullscreen-image-with-nav"));

var _fullscreenImageWithNavExtended = _interopRequireDefault(require("components/fullscreen-image-with-nav-extended"));

require("components/product-spread-grid");

require("components/product-sticky-add-to-cart");

require("components/product-quantity-select");

require("components/yotpo-star-rating");

require("components/yotpo-stars-grid");

require("components/yotpo-product-reviews");

var _recommendationCarousel = _interopRequireDefault(require("components/recommendation-carousel"));

var _product = _interopRequireDefault(require("components/product"));

var _productForm = _interopRequireDefault(require("components/product-form"));

var _productNotifyme = _interopRequireDefault(require("components/product-notifyme"));

var _productHero = _interopRequireDefault(require("components/product-hero"));

var _productFeature = _interopRequireDefault(require("components/product-feature"));

var _productSwitcher = _interopRequireDefault(require("components/product-switcher"));

var _productAccordians = _interopRequireDefault(require("components/product-accordians"));

require("components/product-ingredients");

require("components/product-nutrition");

require("components/product-accordion");

require("components/states-map");

require("components/states-select");

var _statesOverlay = _interopRequireDefault(require("components/states-overlay"));

var _klaviyoStatesNewsletterForm = _interopRequireDefault(require("components/klaviyo-states-newsletter-form"));

var _blogTags = _interopRequireDefault(require("components/blog-tags"));

var _collectionHero = _interopRequireDefault(require("components/collection-hero"));

require("components/collection-headline");

require("components/product-callout-grid");

require("components/product-grid");

require("components/product-grid-item");

require("components/product-callout");

require("components/feature-column");

require("components/page-utility");

require("components/page-grappos");

require("components/page-merchants");

require("components/page-tiles");

var _inview = _interopRequireDefault(require("components/inview"));

require("components/postscript-signup-page");

require("components/shopify-policy");

require("components/turbolinks");

require("components/producer");

require("components/producers-hero");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var inThemeEditor = window.frameElement !== null;
var isShitBrowser = (0, _helpers.isOldIE)();

var Theme = /*#__PURE__*/function (_View) {
  (0, _inherits2["default"])(Theme, _View);

  var _super = _createSuper(Theme);

  function Theme() {
    var _this$state;

    var _this;

    (0, _classCallCheck2["default"])(this, Theme);
    _this = _super.call(this);
    _this.dom = {
      $html: document.querySelector('html')
    };
    _this.state = (_this$state = {
      components: {
        Media: _media["default"],
        Header: _header["default"],
        Accordian: _accordian["default"],
        ProductCardGrid: _productCardGrid["default"],
        FullscreenImageWithNav: _fullscreenImageWithNav["default"],
        FullscreenImageWithNavExtended: _fullscreenImageWithNavExtended["default"],
        ProductGalleryNative: _productGalleryNative["default"],
        AdditivesPopup: _additivesPopup["default"],
        NewsletterPopup: _newsletterPopup["default"],
        KlaviyoNewsletterForm: _klaviyoNewsletterForm["default"],
        ArticleVideoBlock: _articleVideoBlock["default"],
        ArticleGalleryBlock: _articleGalleryBlock["default"],
        RecommendationCarousel: _recommendationCarousel["default"],
        Cart: _cart["default"],
        MiniCart: _miniCart["default"],
        Credits: _credits["default"],
        Locationbar: _locationbar["default"],
        SearchPanel: _searchPanel["default"],
        VideoSection: _videoSection["default"],
        Stockist: _stockist["default"],
        StockistTab: _stockistTab["default"],
        StripHero: _stripHero["default"],
        FilterPanel: _filterPanel["default"],
        SizeGuide: _sizeGuide["default"],
        PaywhirlInfoOverlay: _paywhirlInfoOverlay["default"],
        ProductQuantityNumber: _productQuantityNumber["default"],
        Product: _product["default"],
        ProductForm: _productForm["default"],
        ProductNotifyme: _productNotifyme["default"],
        ProductHero: _productHero["default"],
        ProductFeature: _productFeature["default"],
        ProductSwitcher: _productSwitcher["default"],
        ProductAccordians: _productAccordians["default"],
        StatesOverlay: _statesOverlay["default"],
        KlaviyoStatesNewsletterForm: _klaviyoStatesNewsletterForm["default"],
        BlogTags: _blogTags["default"],
        CollectionHero: _collectionHero["default"],
        Inview: _inview["default"]
      },
      mounted: [],
      loadingTimeout: 250,
      isShitBrowser: (0, _helpers.isOldIE)(),
      loadingClass: 'is-loading',
      noTransitionClass: 'no-transitions',
      touch: 'ontouchstart' in document.documentElement
    }, (0, _defineProperty2["default"])(_this$state, "noTransitionClass", 'no-transitions'), (0, _defineProperty2["default"])(_this$state, "inEditor", window.location.pathname.indexOf('editor') !== -1), _this$state);
    console.log('Theme', (0, _assertThisInitialized2["default"])(_this));
    _this.mountHandler = _this.mountComponents.bind((0, _assertThisInitialized2["default"])(_this));
    _this.unmountHandler = _this.unmountComponents.bind((0, _assertThisInitialized2["default"])(_this));
    _this.refreshHandler = _this.refresh.bind((0, _assertThisInitialized2["default"])(_this));

    _this.mount();

    return _this;
  }

  (0, _createClass2["default"])(Theme, [{
    key: "mount",
    value: function mount() {
      var dom = this.dom,
          state = this.state;
      console.log('Theme : mount', this, inThemeEditor);
      dom.$html.classList.remove(state.noTransitionClass);
      state.touch ? dom.$html.classList.add('is-touch') : dom.$html.classList.add('no-touch');
      document.addEventListener('turbolinks:click', this.setLoading.bind(this));
      document.addEventListener('turbolinks:before-render', this.removeLoading.bind(this));
      document.addEventListener('turbolinks:before-render', this.unmountHandler);
      document.addEventListener('turbolinks:before-visit', this.unmountHandler);
      document.addEventListener('turbolinks:load', this.mountHandler);
      document.addEventListener('turbolinks:render', this.mountHandler);
      document.addEventListener('theme:refreshComponents', this.mountHandler);
      document.addEventListener('turbolinks:load', this.refreshHandler);

      if (inThemeEditor) {
        console.log('Theme : mount : inThemeEditor', this);
        this.mountComponents();
        document.addEventListener('shopify:section:load', this.mountHandler);
        document.addEventListener('shopify:section:unload', this.unmountHandler);
      }
    }
  }, {
    key: "refresh",
    value: function refresh() {
      console.log('Theme : refresh', this);

      if (window.yotpo && typeof yotpo.refreshWidgets === 'function') {
        yotpo.refreshWidgets();
      }
    }
  }, {
    key: "setLoading",
    value: function setLoading() {
      var dom = this.dom,
          state = this.state;
      console.log('Theme : setLoading', this);
      dom.$html.classList.add(state.loadingClass);
      state.loading = true;
    }
  }, {
    key: "removeLoading",
    value: function removeLoading() {
      var dom = this.dom,
          state = this.state;
      console.log('Theme : removeLoading', this);
      setTimeout(function () {
        dom.$html.classList.remove(state.loadingClass);
        state.loading = false;
      }, state.loadingTimeout);
    }
  }]);
  return Theme;
}(_View2["default"]);

document.addEventListener('DOMContentLoaded', function (event) {
  new Theme();

  if (!inThemeEditor || !isShitBrowser) {
    _turbolinks["default"].start();

    _turbolinks["default"].setProgressBarDelay();
  }
});